var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "signup-content" }, [
      _vm.$route.fullPath != "/newprofile/company/billing"
        ? _c("h1", { staticClass: "text-uppercase mb-5" }, [_vm._v("Billing")])
        : _vm._e(),
      _vm._v(" "),
      _c("h3", [_vm._v("COMING SOON")])
    ]),
    _vm._v(" "),
    _vm.$route.fullPath != "/newprofile/company/billing"
      ? _c("div", { staticClass: "signup-footer" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-block btn-lg",
              on: {
                click: function($event) {
                  return _vm.goToSentVerification()
                }
              }
            },
            [_vm._v("Next")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("h3", { staticClass: "col-4 page-heading" }, [_vm._v("Billing")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d900789e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d900789e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Billing.vue
// module id = null
// module chunks = 